import { C } from '../utils/constants';

export const PhoenixLogo = ({ size = 80, nav = false }) => (
  <img
    src="/ry-logo.png"
    alt="Recondition Yourself"
    style={{
      width: size, height: size, objectFit: 'contain', display: 'block', flexShrink: 0,
      filter: nav
        ? 'drop-shadow(0 2px 6px rgba(245,166,35,.5))'
        : 'drop-shadow(0 4px 18px rgba(245,166,35,.6))',
    }}
    onError={e => { e.target.style.display = 'none'; }}
  />
);
